import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: null,
    authenticated: false,
    user: {},
    dpa: {},
    menu: [],
    fcm: null,
    reload: false,
    company: {
      company_name: 'SIMPELBANG',
      logo: require('@/assets/logo/favicon_full.png'),
      fav_icon: require('@/assets/logo/favicon.png')
    },
    unit_id: '',
    color: '#DD5826',
    counter: {
      total_company_quota: 0,
      total_company_quota_used: 0,
      total_company_quota_sisa: 0
    },

    year: new Date().getFullYear()
  },
  mutations: {
    setToken(state, accessToken) {
      state.token = accessToken
      state.authenticated = true
    },
    setUser(state, accessUser) {
      state.user = accessUser
    },
    setMenu(state, accessMenu) {
      state.menu = accessMenu
    },
    setFcm(state, accessFcm) {
      state.fcm = accessFcm
    },
    setReload(state, accessReload) {
      state.reload = accessReload
    },
    setCompany(state, accessCompany) {
      state.company = accessCompany
    },
    setColor(state, accessColor) {
      state.color = accessColor
    },
    setUnitId(state, accessUnitId) {
      state.unit_id = accessUnitId
    },
    setCounter(state, accessCounter) {
      state.counter = accessCounter
    },

    setYear(state, accessYear) {
      state.year = accessYear
    },
    setDpa(state, accessDpa) {
      state.dpa = accessDpa
    }
  },
  actions: {},
  modules: {}
})